import React from 'react'
import { shape, string, bool, func } from 'prop-types'
import { getIn } from 'formik'
import AmountWUnitInput from '~/components/common/AmountWUnitInput'

const FormAmountWUnitInput = ({
  onSelect,
  form,
  field,
  error,
  clearable,
  helperText,
  inputProps,
  onChange,
  disabled,
  ...props
}) => (
  <>
    <AmountWUnitInput
      error={
        !!error ||
        (!!getIn(form.touched, field.name) && !!getIn(form.errors, field.name))
      }
      helperText={
        helperText ||
        (getIn(form.touched, field.name) && getIn(form.errors, field.name))
      }
      inputProps={{
        name: `${field?.name}.amount`,
        ...inputProps,
      }}
      type={field?.value?.unit}
      onChange={(e) => {
        if (onChange) {
          onChange(e.target.value ? Number(e.target.value) : e.target.value)
        } else {
          form.setFieldValue(
            `${field?.name}.amount`,
            e.target.value ? Number(e.target.value) : e.target.value,
          )
        }
      }}
      value={field?.value?.amount}
      onSelect={(val) => {
        if (onSelect) {
          onSelect(val)
        } else {
          form.setFieldValue(`${field?.name}.unit`, val)
        }
      }}
      disabled={disabled || !!form.values.__readOnly}
      {...props}
    />
  </>
)

FormAmountWUnitInput.defaultProps = {
  inputProps: {},
  clearable: false,
  error: '',
  helperText: '',
  onSelect: null,
  onChange: null,
  disabled: false,
}

FormAmountWUnitInput.propTypes = {
  onSelect: func,
  onChange: func,
  form: shape().isRequired,
  inputProps: shape(),
  field: shape().isRequired,
  clearable: bool,
  error: string,
  helperText: string,
  disabled: bool,
}

export default FormAmountWUnitInput
